import React from 'react';
import PropTypes from 'prop-types';
import ComboBox from '../Form/ComboBox';
import QuoteHistoryActions from '../../Actions/QuoteHistoryActions';
import QuoteHistorySymbolsActions from '../../Actions/QuoteHistorySymbolsActions';
import QuoteHistoryStore from '../../Stores/QuoteHistoryStore';
import QuoteHistorySymbolsStore from '../../Stores/QuoteHistorySymbolsStore';

class HistorySymbol extends React.Component {
  static defaultProps = {
    disabled: false,
    name: '',
    value: 0
  };

  static propTypes = {
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      historyId: this.props.value === Constants.Diff ? Constants.Diff : 0,
      haveDiff: this.props.value === Constants.Diff
    };
    this.onChangeStore = this.onChangeStore.bind(this);
    this.onChangeHistory = this.onChangeHistory.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    QuoteHistoryStore.addChangeListener(this.onChangeStore);
    QuoteHistorySymbolsStore.addChangeListener(this.onChangeStore);
    QuoteHistoryActions.update();
    QuoteHistorySymbolsActions.update();
  }

  componentWillUnmount() {
    QuoteHistoryStore.removeChangeListener(this.onChangeStore);
    QuoteHistorySymbolsStore.removeChangeListener(this.onChangeStore);
  }

  onChangeStore() {
    let histSymbol = QuoteHistorySymbolsStore.get(this.props.value);
    let historyId = this.state.historyId;
    if (histSymbol) {
      historyId = histSymbol.HistoryId;
    }

    this.setState({historyId: historyId});
  }

  onChangeHistory(name, value) {
    let intValue = value === Constants.Diff ? value : parseInt(value, 10);
    this.setState({historyId: intValue});
  }

  onChange(name, value) {
    let intValue = value === Constants.Diff ? value : parseInt(value, 10);
    this.props.onChange && this.props.onChange(this.props.name, intValue);
  }

  getHistoryOptions() {
    let options = QuoteHistoryStore.getForSelect();

    if (this.state.haveDiff) {
      options.push({value: Constants.Diff, label: Constants.Diff});
    }

    return options;
  }

  getSymbolOptions() {
    let symbols = QuoteHistorySymbolsStore.getSymbols(this.state.historyId);
    let options = symbols.map(sym => ({value: sym.Id, label: sym.Name + "(" + sym.Id + ")"}));

    if (this.state.haveDiff) {
      options.push({value: Constants.Diff, label: Constants.Diff});
    }

    return options;
  }

  getParentSymbolId(id) {
    if (id === Constants.Diff) {
      return id;
    }

    let sym = QuoteHistorySymbolsStore.get(id);
    if (sym && sym.ParentId !== 0) {
      return this.getParentSymbolId(sym.ParentId);
    }

    return id;
  }

  render() {
    return (<div>
      <ComboBox name="historyId"
                grid={1 / 2}
                sorted={true}
                value={this.state.historyId}
                options={this.getHistoryOptions()}
                onChange={this.onChangeHistory}
                disabled={this.props.disabled}
      />
      <ComboBox name={this.props.name}
                grid={1 / 2}
                sorted={true}
                value={this.getParentSymbolId(this.props.value)}
                options={this.getSymbolOptions()}
                onChange={this.onChange}
                disabled={this.props.disabled}
      />
    </div>);
  }
}

export default HistorySymbol;



// WEBPACK FOOTER //
// ./src/js/Component/Form/HistorySymbol.jsx